import { render, staticRenderFns } from "./user-create.view.vue?vue&type=template&id=58db6b0a&"
import script from "./user-create.view.ts?vue&type=script&lang=js&"
export * from "./user-create.view.ts?vue&type=script&lang=js&"
import style0 from "./user-create.view.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports